import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CampaignItemDto } from '@api/Api';

import CampaignCreationStep from './CampaignCreationStep';
import InviteToCampaignStep from './InviteToCampaignStep';

type CampaignCreationOnboardingProps = {
  onCloseModal: () => void;
};

export default function CampaignCreationOnboarding({
  onCloseModal
}: CampaignCreationOnboardingProps) {
  const navigate = useNavigate();
  const [step, setStep] = useState<'campaign' | 'invite'>('campaign');
  const [campaign, setCampaign] = useState<CampaignItemDto>();

  const onClose = (campaignId?: string) => {
    onCloseModal();
    if (campaignId) navigate(`/campaigns/single/${campaignId}`);
  };

  if (step === 'invite' && campaign) {
    return <InviteToCampaignStep onCloseModal={onClose} campaign={campaign} />;
  }

  return (
    <CampaignCreationStep
      onCloseModal={onClose}
      setStep={setStep}
      setCampaign={setCampaign}
    />
  );
}
